export const ADD_USERS_TO_GROUP_MODAL_SHOW = 'ADD_USERS_TO_GROUP_MODAL_SHOW'; // dispatched from gwt currently
export const ADD_USERS_TO_GROUP_MODAL_HIDE = 'ADD_USERS_TO_GROUP_MODAL_HIDE';

export const INVITE_CREATE_GROUP = 'INVITE_USERS_CREATE_GROUP';
export const INVITE_CREATE_GROUP_START = `${INVITE_CREATE_GROUP}_START`;
export const INVITE_CREATE_GROUP_SUCCESS = `${INVITE_CREATE_GROUP}_SUCCESS`;
export const INVITE_CREATE_GROUP_FAIL = `${INVITE_CREATE_GROUP}_FAIL`;

export const INVITE_ADD_USER = 'INVITE_USERS_ADD_GROUP_MEMBER';
export const INVITE_ADD_USER_START = `${INVITE_ADD_USER}_START`;
export const INVITE_ADD_USER_SUCCESS = `${INVITE_ADD_USER}_SUCCESS`;
export const INVITE_ADD_USER_FAIL = `${INVITE_ADD_USER}_FAIL`;

export const SET_SELECTED_GROUP = 'INVITE_USERS_SET_SELECTED_GROUP';

export const hideModal = () => ({
  type: ADD_USERS_TO_GROUP_MODAL_HIDE,
});

export const setSelectedGroup = group => ({
  type: SET_SELECTED_GROUP,
  payload: group,
});
